<template>
  <b-card
    class="card-transparent-background card-media-container-doomyoga mt-1 mb-0 py-0"
    :title="list_title"
  >
    <VueSlickCarousel
      v-bind="settings_slick"
      class="slick-container-dy"
      v-if="list_items != null && list_items.length > 0"
    >
      <template #prevArrow>
        <div class="custom-arrow">
          <img src="@/assets/images/doom-yoga/arrow-left.png" />
        </div>
      </template>
      <div
        v-for="item in list_items.filter((v) => v.library_media.length > 0)"
        :key="item.id"
        class=""
      >
        <router-link
          :to="'/doom_yoga/' + type + '/playlist/' + item.id"
          class="card-link eventLink"
        >
          <SimpleMediaCard
            client_name="DY"
            :title="item.title"
            :duration="item.time_duration"
            :img_src="item.library_media[0].cover_image.full_path"
          />
        </router-link>
      </div>
      <template #nextArrow>
        <div class="custom-arrow">
          <img src="@/assets/images/doom-yoga/arrow-right.png" />
        </div>
      </template>
    </VueSlickCarousel>
  </b-card>
</template>

<script>
import SimpleMediaCard from "./SimpleMediaCard.vue";
export default {
  name: "MediaSimpleCardList",
  components: { SimpleMediaCard },
  props: ["client_name", "list_title", "list_items", "type"],
  data() {
    return {
      settings_slick: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/media_components/MediaSimpleCardList.vue